import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { catchError, map, tap } from 'rxjs/operators';
import 'rxjs/add/operator/catch';
import { DbService } from './db.services';

interface Post {
  firstName: string
}

@Injectable()
export class CommonService {
  private appURL: string = environment.apiUrl;
  private _loginUrl: string = environment.loginUrl;
  private uploadUrl: string = environment.uploadUrl;

  posts: Observable<Post[]>;

  constructor(private http: HttpClient, private _db: DbService,) { }
  login(customer) {
    return this.http.post(this._loginUrl + 'login', JSON.stringify({ customer: customer }));
  }

  project_change(customer) {
    return this.http.post(this._loginUrl + 'project_change', JSON.stringify({ customer: customer }));
  }

  login_check(customer) {
    return this.http.post(this._loginUrl + 'login_check', JSON.stringify({ customer: customer }));
  }

  addAdmin(customer) {
    return this.http.post(this.appURL + 'addAdmin', JSON.stringify({ customer: customer }));
  }

  generate_otp(user, type) {
    return this.http.post(this._loginUrl + 'generate_otp', JSON.stringify({ user: user, type: type }));
  }

  send_otp(data) {
    return this.http.post(this._loginUrl + 'send_otp', JSON.stringify({ data: data }));
  }


  register(user) {
    return this.http.post(this._loginUrl + 'signUp', JSON.stringify({ user: user }));
  }
  logout() {
    return this.http.get(this._loginUrl + 'logout');
  }
  session() {
    return this.http.get(this._loginUrl + 'session');
  }
  // Get Login user data from Localstorage
  getLocalSession(sessionData) {
    return localStorage.getItem(sessionData);
  }
  // Get Login user data from Localstorage
  setLocalSession(name, data) {
    localStorage.setItem(name, JSON.stringify(data));
  }
  setCurrentApp(d) {
    return this.setLocalSession('currentApp', d);
  }
  getCurrentApp() {
    return JSON.parse(this.getLocalSession('currentApp'));
  }
  setCurrentComp(d) {
    return this.setLocalSession('currentComp', d);
  }
  getCurrentComp() {
    return JSON.parse(this.getLocalSession('currentComp'));
  }
  getcompany(uid, userType, level, parentChild) {
    return this.http.post(this.appURL + 'getContractorProfile',
      JSON.stringify({ uid: uid, userType: userType, level: level, parentChild: parentChild }));
  }
  saveCompany(company) {
    return this.http.post(this.appURL + 'subcontactorSave', JSON.stringify({ company: company }));
  }
  getEmployeelist() {
    return this.http.get(this.appURL + 'getEmployeeNames');
  }

  getEmployees() {
    return this.http.post(this.appURL + 'getEmployees', JSON.stringify({}));
  }

  getcompanySearch(id) {
    return this.http.post(this.appURL + 'getContractorProfileSearch', JSON.stringify({ id: id }));
  }

  updateCertificate(certList, currOrg, currUser) {
    return this.http.post(this.appURL + 'updateCertificate', JSON.stringify({ certList: certList, currOrg: currOrg, currUser: currUser }));
  }

  getConEmpList(contId) {
    return this.http.post(this.appURL + 'getConEmpList', JSON.stringify({ contId: contId }));
  }

  uploadCertificate(formData, certId, contId, cId) {
    return this.http.post(this.appURL + 'upload.php?page=contractor&certId=' + certId + '&contId=' + contId + '&cId=' + cId, formData);
  }

  uploadResume(formData, empId, currentUser, uploadtype) {
    return this.http.post(this.appURL + 'upload.php?page=employee&empId=' + empId + '&currentUser='
      + currentUser + '&uploadtype=' + uploadtype, formData);
  }

  uploadproof(formData, secId, empId, currentUser, uploadtype) {
    return this.http.post(this.appURL + 'upload.php?page=sec3&secId=' + secId + '&empId='
      + empId + '&currentUser=' + currentUser + '&uploadtype=' + uploadtype, formData);
  }

  saveEmployee(emp) {
    return this.http.post(this.appURL + 'candidateSave', JSON.stringify({ emp: emp }));
  }


  lowertierSave(subCont, contId) {
    return this.http.post(this.appURL + 'saveLowertier', JSON.stringify({ subCont: subCont, contId: contId }));
  }

  uploadFile(formData: any, name) {
    return this.http.post(this.uploadUrl + 'upload.php?page=' + name, formData);
  }

  movePrevious(subcont, contId) {
    return this.http.post(this.appURL + 'subContractorPrve', JSON.stringify({ subcont: subcont, contId: contId }));
  }

  moveNext(subcont, contId) {
    return this.http.post(this.appURL + 'subContractorNext', JSON.stringify({ subcont: subcont, contId: contId }));
  }

  deleteCertificate(certId, cont) {
    return this.http.post(this.appURL + 'deleteCertificate', JSON.stringify({ certId: certId, cont: cont }));
  }

  getOrgId(currentOrg) {
    return this.http.post(this.appURL + 'getOrgId', JSON.stringify({ currentOrg: currentOrg }));
  }
  Objtodate(obj) {
    if (typeof obj === 'object') {
      return obj.month + '/' + obj.day + '/' + obj.year;
    } else {
      return 'mm/dd/yyyy';
    }
  }
  Objtodates(obj) {

    if (typeof obj === 'object') {
      return obj.day + '-' + obj.month + '-' + obj.year;
    } else {
      return '';
    }
  }
  strToDate(str) {
    const a = str.split('/');
    return { date: { year: a[2], month: a[0], day: a[1] } };
  }
  strToDates(str) {
    if (typeof str === 'object') {
      const a = str.split('-');
      return { date: { year: a[2], month: a[0], day: a[1] } };
    } else {
      return '';
    }
  }
  getSubContractor(contId) {
    return this.http.post(this.appURL + 'getSubContractor', JSON.stringify({ contId: contId }));
  }

  getBilling(subContId) {
    return this.http.post(this.appURL + 'getBilling', JSON.stringify({ subContId: subContId }));
  }


  saveSec3Applicant(applicant, empid) {
    return this.http.post(this.appURL + 'saveSec3Applicant', JSON.stringify({ applicant: applicant, empid: empid }));
  }

  getSec3Applicant(empid) {
    return this.http.post(this.appURL + 'getSec3Applicant', JSON.stringify({ empid: empid }));
  }

  hireApplicant(hire) {
    return this.http.post(this.appURL + 'hireApplicant', JSON.stringify({ hire: hire }));
  }
  saveExpenditure(expen, currOrg) {
    return this.http.post(this.appURL + 'saveExpenditure', JSON.stringify({ expen: expen, currOrg: currOrg }));
  }

  deleteExpenPayment(id) {
    return this.http.post(this.appURL + 'deleteExpenPayment', JSON.stringify({ id: id }));
  }
  deleteExpenBilling(id) {
    return this.http.post(this.appURL + 'deleteExpenBilling', JSON.stringify({ id: id }));
  }
  saveworkinghours(workinghours, month, currentOrg) {
    return this.http.post(this.appURL + 'saveworkinghours',
      JSON.stringify({ workinghours: workinghours, month: month, currentOrg: currentOrg }));
  }
  getCurrworkinghours(month, currentOrg) {
    return this.http.post(this.appURL + 'getCurrworkinghours', JSON.stringify({ month: month, currentOrg: currentOrg }));
  }
  getCertificate(currOrg) {
    return this.http.post(this.appURL + 'getCertificate', JSON.stringify({ currOrg: currOrg }));
  }
  getCurrentDate() {
    const dateObj = new Date();
    const month = dateObj.getUTCMonth() + 1;
    const day = dateObj.getUTCDate();
    const year = dateObj.getUTCFullYear();
    return { date: { year: year, month: month, day: day } };
  }
  getBlankDate() {
    return { date: { year: null, month: null, day: null } };
  }
  terminateEmp(hire_id, termDate) {
    return this.http.post(this.appURL + 'terminated', JSON.stringify({ hire_id: hire_id, termDate: termDate }));
  }
  getCurrexpenditure(month, contId) {
    return this.http.post(this.appURL + 'getCurrexpenditure', JSON.stringify({ month: month, contId: contId }));
  }
  getEmployeeReports(contId, dates) {
    return this.http.post(this.appURL + 'getEmployeeReports', JSON.stringify({ dates: dates, contId: contId }));
  }
  getContractsReports(contId, dates) {
    return this.http.post(this.appURL + 'getContractsReports', JSON.stringify({ dates: dates, contId: contId }));
  }

  forgotPassword(user, siteUrl) {
    return this.http.post(this.appURL + 'forgetPassword', JSON.stringify({ user: user, siteUrl: siteUrl }));
  }

  verifyToken(token) {
    return this.http.post(this.appURL + 'verifyToken', JSON.stringify({ token: token }));
  }

  resetPassword(user) {
    return this.http.post(this.appURL + 'resetPassword', JSON.stringify({ user: user }));
  }

  saveproject(pro, currUser) {
    return this.http.post(this.appURL + 'saveproject', JSON.stringify({ pro: pro, currUser: currUser }));
  }

  getsavedprojects(currUser) {
    return this.http.post(this.appURL + 'getsavedprojects', JSON.stringify({ currUser: currUser }));
  }

  getproject(id, currUser) {
    return this.http.post(this.appURL + 'getproject', JSON.stringify({ id: id, currUser: currUser }));
  }

  getapplicant(id) {
    return this.http.post(this.appURL + 'getapplicant', JSON.stringify({ id: id }));
  }

  getsavedprojects1(currUser, pro_id) {
    return this.http.post(this.appURL + 'getsavedprojects1', JSON.stringify({ currUser: currUser, pro_id: pro_id }));
  }

  deleteproject(id) {
    return this.http.post(this.appURL + 'deleteproject', JSON.stringify({ id: id }));
  }

  agree_privacy(currUser) {
    return this.http.post(this.appURL + 'agree_privacy', JSON.stringify({ currUser: currUser }));
  }

  getcurrentproject(id) {
    return this.http.post(this.appURL + 'getcurrentproject', JSON.stringify({ id: id }));
  }

  deleteuploads(data) {
    return this.http.post(this.appURL + 'deleteuploads', JSON.stringify({ data: data }));
  }

  comptab(id, name, value, currentUser) {
    return this.http.post(this.appURL + 'comptab', JSON.stringify({ id: id, name: name, value: value, currentUser: currentUser }));
  }

  reportDivisionList(emp, currentOrg, currentUser, proid, asc, name, ref_src) {
    return this.http.post(this._loginUrl + 'getempdivision', JSON.stringify({ empId: emp, currentOrg: currentOrg, currentUser: currentUser, proid: proid, asc: asc, name: name, ref_src: ref_src }));
  }

  daystamp(data) {
    return this.http.post(this.appURL + 'daystamp', JSON.stringify({ data: data }));
  }

  saveShortTerm(datas, currentOrg, currentUser) {

    return this.http.post(this.appURL + 'saveShortTerm', JSON.stringify({ datas: datas, currentOrg: currentOrg, currentUser: currentUser }));
  }

  getRef_src(currentOrg) {
    return this.http.post(this.appURL + 'getRef_src', JSON.stringify({ currentOrg: currentOrg }));
  }

  getShortTerm(contractor_id, id) {
    return this.http.post(this.appURL + 'getShortTerm', JSON.stringify({ contractor_id: contractor_id, id: id }));
  }

  checkid(contractor_id, id) {
    return this.http.post(this.appURL + 'checkid', JSON.stringify({ contractor_id: contractor_id, id: id }));
  }

  getcompPrevNextList(compId, pre_nxt, currentUser, currentOrg) {
    return this.http.post(this.appURL + 'getcompPrevNextList',
      JSON.stringify({ compId: compId, pre_nxt: pre_nxt, currentUser: currentUser, currentOrg: currentOrg }));
  }

  savedevAgenOpt(devAgenOpt, currentUser) {
    return this.http.post(this.appURL + 'savedevAgenOpt',
      JSON.stringify({ devAgenOpt: devAgenOpt, currentUser: currentUser }));
  }

  deletedevAgenOpt(devAgenOpt) {
    return this.http.post(this.appURL + 'deletedevAgenOpt',
      JSON.stringify({ devAgenOpt: devAgenOpt }));
  }

  getdevAgenOpt() {
    return this.http.post(this.appURL + 'getdevAgenOpt',
      JSON.stringify({}));
  }

  getNewReq_id(currentOrg) {
    return this.http.post(this.appURL + 'getNewReq_id', JSON.stringify({ currentOrg: currentOrg }));
  }

  getreqPrevNextList(req_id, currentOrg, pre_nxt) {
    return this.http.post(this.appURL + 'getreqPrevNextList', JSON.stringify({ req_id: req_id, pre_nxt: pre_nxt, currentOrg: currentOrg }));
  }

  del_short(id) {
    return this.http.post(this.appURL + 'del_short', JSON.stringify({ id: id }));
  }

  databasequery(id) {
    return this.http.post(this.appURL + 'databasequery', JSON.stringify({ id: id }));
  }






  get_firebase_data(currentUser, val) {
    return new Promise((resolve, reject) => {
      this._db.get_firebase_data(currentUser, val).subscribe(d => {
        resolve(d);
      });
    });
  }

  transfer_firebase_data(id, addFid, currentUser) {
    return new Promise((resolve, reject) => {
      this._db.transfer_firebase_data(id, addFid, currentUser).subscribe(d => {
        resolve(d);
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/common.service.ts